import React, { FC } from 'react';
import Scrollbars from 'react-custom-scrollbars';

import UcpDetailsListItem from './ucp-details-list-item';

interface UcpDetailsListProps {
  data: { refNumber: string; sum: string; link?: string }[];
}

const UcpDetailsList: FC<UcpDetailsListProps> = ({ data }) => (
  <Scrollbars style={{ height: '224px' }} autoHide>
    <div className="ucp-details__list-wrapper">
      <ul className="ucp-details__list">
        {data.map((item, index) => (
          <li className="ucp-details__item" key={`ucp-details__item-${index}`}>
            <UcpDetailsListItem
              link={item.link}
              refNumber={item.refNumber}
              sum={item.sum}
            />
          </li>
        ))}
      </ul>
    </div>
  </Scrollbars>
);

export default UcpDetailsList;
